# this file is the beginning stages of a refactor of angular/customer/services/customerApplicationService
class ApplicationService
  $inject: ["$cookies", "$filter", "$http", "$q", "$rootScope", "$window", "AvantErrorService", "ConfigService", "ProductService"]

  constructor: ($cookies, $filter, $http, $q, $rootScope, $window, AvantErrorService, ConfigService, ProductService) ->
    @$cookies          = $cookies
    @$filter           = $filter
    @$http             = $http
    @$q                = $q
    @$rootScope        = $rootScope
    @$window           = $window
    @AvantErrorService = AvantErrorService
    @ConfigService     = ConfigService
    @ProductService    = ProductService

  idFromRoute: ->
    val = parseInt(@$window.location.pathname.replace(/.*\//, ''))
    if _.isNaN(val) then null else val
  target_application_id: ->
    @idFromRoute() || @$window.customer_application_id
  response_data: null
  logged_in: false
  already_viewed_personal: false
  page_config: {}
  getProgress: (flush = false, completedPage = null, urlParams = {}) ->
    deferred = @$q.defer()
    if @page and !flush
      deferred.resolve(@response_data)
    else
      @$rootScope.$broadcast("fetch_data:in_progress")
      @force_resubmit = null
      angular.extend(urlParams, { page: String(completedPage) })
      @$http(
        method: "GET"
        url: "#{@ConfigService.apiBaseUrl(@target_application_id())}/progress"
        params: urlParams
      ).then(
        (response) =>
          { data } = response
          if data.new_application_id?
            loc = @ConfigService.viewBaseUrl(data.new_application_id)
            @$rootScope.$broadcast('customer:redirect', loc)
            return @$window.location.replace(loc)
          else
            @handleResponse(deferred, data)
          response
        , => deferred.reject() # could send message as param
      ).finally => @$rootScope.$broadcast('fetch_data:complete')
    deferred.promise

  submitPage: (page, request_data = {}) ->
    @$rootScope.$broadcast('showLoadingMessages', @$filter('StageToWordArray')(page))
    deferred = @$q.defer()
    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(@target_application_id())}/submit_page"
      data:
        data: request_data
        page: page
    ).then(
      (response) =>
        { data } = response
        @handleResponse(deferred, data)
        response
      , => deferred.reject() # could send message as param
    )
    deferred.promise

  handleResponse: (deferred, response_data) ->
    @server_side_errors = response_data.server_side_errors
    @data = response_data.data
    @response_data = @transformResponseData(response_data)
    @[k] = v for k, v of @response_data
    @$rootScope.$broadcast('customer:login', @logged_in)
    if @response_data and @response_data.data
      @AvantErrorService.setContext
        customer_application: @response_data.data.customer_application
        server_side_errors:   @response_data.server_side_errors
        viewable_pages:       @response_data.viewable_pages
        page:                 @response_data.page
      # add "admin_user:" prefix to events created by admin_user logged in as customer
      if @response_data.data.product
        @ProductService.refreshData @response_data.data.product, true
        # can remove later after more refactoring
        delete @response_data.data.product
        delete @data.product
      if @response_data.boolean_gates
        @$rootScope.$broadcast('boolean_gates:data', @response_data.boolean_gates)
    # Protecting nil register_once for letters
    @fireViewablePageEvents()
    deferred.resolve(@response_data)

  track: (page, event_type = 'viewed', data = {}) ->
    defaultData = {
      page: page
      event_type: event_type
      referrer: @$window.document.referrer
      user_agent: @$window.navigator.userAgent
    }
    trackingData = Object.assign({}, defaultData, data)
    deferred = @$q.defer()
    @$http(
      method: "POST"
      url: "#{@ConfigService.apiBaseUrl(@target_application_id())}/track_event"
      data: trackingData
    ).then(
      (response) =>
        { data } = response
        deferred.resolve(data)
        response
      ,
      => deferred.reject()
    )
    deferred.promise

  setAutosuggestAddress: (bool) ->
    @$http.post(
      "#{@ConfigService.apiBaseUrl(@target_application_id())}/set_autosuggest",
      {autosuggest: !!bool}
    )

  fireViewablePageEvents: ->
    commonEventData =
      "app:customer:address_state": @data?.customer_address?.state
      "app:viewable_pages": @viewable_pages

  pageIndex: (page) ->
    @page_to_index_dictionary[page] || -1

  # should get returned by API in config data, not hardcoded here
  page_to_index_dictionary:
    'declined': 0
    'personal': 1
    'rates_terms': 2
    'contract': 3
    'bank_account': 4
    'additional_information': 5
    'payment_details' : 6
    'verification' : 7
    'completed': 100

  cannotSignContractTilApproved: ->
    (@page is "contract") and (@viewable_pages.length > 3)

  applicationCompleted: ->
    (@page in ["verification", "completed"]) ||
    (@cannotSignContractTilApproved())

  applicationKickedBack: ->
    (@page != 'completed') && _.contains(@data.customer_application.viewed_stages, 'completed')

  removeHiddenSections: (requirements) ->
    result = []
    _.each(requirements, (section_config) ->
      should_hide = _.every(section_config.fields, (fields, ivar) ->
        _.every(fields, (field_config, field) -> field_config.hide is true)
      )
      result.push(section_config) unless should_hide
    )
    result

  transformResponseData: (response_data) ->
    new_data = {}
    new_data['page_config'] = {}
    if response_data.page_requirements? && !_.isEmpty(response_data.page_requirements)
      _.every(response_data.page_requirements, (page_requirements, page) =>
        new_data['page_config'][page] ||= {}
        new_data['page_config'][page]['sections'] = @removeHiddenSections(page_requirements)
        new_data['page_config'][page]['validations'] = @pageValidationRequirements(page_requirements)
      )
      new_data

    angular.extend(response_data, new_data)

  pageValidationRequirements: (page_requirements) ->
    result = {}
    _.each(page_requirements, (section_config) ->
      _.each(section_config.fields, (fields, ivar) ->
        _.each(fields, (field_config, field) ->
          result["#{ivar}.#{field}"] = field_config
        )
      )
    )
    if @shouldHideCompletedFields()
      result = @hideCompletedFields(result)
    result

  leadsModalCookieId: ->
    "showedLeadsModalFor#{@data.customer_application.id}"

  leadForAvant: ->
    @data.customer_application.application_owner == 'avantcredit'

  leadFirstVisit: ->
    !_.isEmpty(@data.lead) and !@$cookies.get(@leadsModalCookieId())

  setLeadFirstVisit: ->
    @$cookies.put(@leadsModalCookieId(), true)

  leadInfoRequired: ->
    !_.isEmpty(@data.lead) and !_.isEmpty(@server_side_errors)

  shouldShowLeadsModal: ->
    return false if @data.lead?.disable_welcome_modal
    (@leadForAvant() and @leadFirstVisit()) or @data.lead?.force_welcome_modal

  shouldHideCompletedFields: ->
    @leadInfoRequired() &&
      !@data.lead?.prefill &&
      @data.customer_application?.stage == 'personal' &&
      @data.config.hide_post_lead_completed_fields

  alwaysShowField: (requirement) ->
    requirement.force_show || (requirement.checkbox && !requirement.hide)

  hideCompletedFields: (requirements) ->
    # Hide all fields if more info required from lead
    _.each requirements, (req) =>
      angular.extend req, hide: true unless @alwaysShowField(req)
    # Collect the visible fields from serverSideErrors and update requirements
    # Converts array of fields containing array of errors into hash of field keys
    fieldsToShow = _.reduce @server_side_errors, (acc, err) ->
      angular.extend acc, new -> @[k] = hide: false for k,v of err; @
    , {}

    for ivar, updates of fieldsToShow
      if requirements[ivar]
        angular.extend requirements[ivar], updates

    requirements

  # Returns a promise that will get resolved unless the backend explicitly
  # says the current Angular app is the application, in which case it'll
  # redirect to it and reject the promise.
  ensureDashboard: ->
    deferred = @$q.defer()

    @$http.get(
      "#{@ConfigService.apiBaseUrl(@target_application_id())}/current_angular_app"
    ).then(
      (response) =>
        { data } = response
        if data.current_angular_app == 'application'
          return @$window.location.href = "#{@ConfigService.applicationPrefix}/#{@target_application_id()}"
          # no need to reject, we're exiting the page here
        else
          deferred.resolve()
        response
      , -> deferred.resolve()
    )

    deferred.promise

angular
.module("avant.customer_applications.services")
.service("ApplicationService", [
  "$cookies",
  "$filter",
  "$http",
  "$q",
  "$rootScope",
  "$window",
  "AvantErrorService",
  "ConfigService",
  "ProductService", ApplicationService])

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = ApplicationService
  exports.ApplicationService = ApplicationService
else
  window.ApplicationService = ApplicationService
